export default __webpack_public_path__ + "static/media/farmacia.e8908a8e.svg";